import {
  GET_SERVICE_STYLISTS,
  GET_SERVICE_STYLISTS_FAILURE,
  GET_SERVICE_STYLISTS_SUCCESS,
} from './action';

const initialState = { loading: false, data: null, error: '' };

const getServiceStylistsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SERVICE_STYLISTS:
      return { ...state, loading: true };
    case GET_SERVICE_STYLISTS_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_SERVICE_STYLISTS_FAILURE:
      return { ...state, loading: false, data: null, error: action.payload };
    default:
      return state;
  }
};

export default getServiceStylistsReducer;
